import React from 'react'
import selectn      from 'selectn'

// Use this component to display non linked details like Toss
const OtherDetail = ({
  type = '',
  value = ''
}) => {
  return (
    <div className="match-detail--item">
        <div className="match-detail--left">
          { type && <h4>{type}</h4> || '' }
        </div>
        <div className="match-detail--right">
          {
            value && <span>{value}</span> || ''
          }
        </div>
    </div>
  )
}

const MatchDetailItem = ({
  type = '',
  persons = []
}) => {
  return (
    <div className="match-detail--item">
        <div className="match-detail--left">
          { persons.length && <h4>{type}</h4> || '' }
        </div>
        <div className="match-detail--right">
          {
            persons.map((o,i) => {
              return <span key={i} dangerouslySetInnerHTML={{ __html : (o.imgicon ? `<img data-src=${o.imgicon} class="lazyload"/>` : '') + `<a name=${o.trackingName} href=${o.href}>${o.name}</a>` }}></span>
            })
          }
        </div>
    </div>
  )
}

/**
 * React Match Details element
 * @return {React.PropTypes.element} Match details
 */
const MatchDetails = ({
  officials = {},
  debuts = [],
  hoursOfPlay = '',
  venue = '',
  venueLink = '',
  temperature = '',
  location = {},
  hideShowClass = false,
  toss = '',
  playerOfMatch = [],
  playerOfSeries = [],
  matchFormat = '',
  series = [],
  seriesResult = '',
  matchNo = '',
  season = '',
  matchDays = '',
  points = '',
  ballsPerOver = '',
  playersperside = '',
  featuredAthletesDetails = [],
  playerReplacement = []
}) => {
  const umpire = officials.umpire && officials.umpire || []
  const tvUmpire = officials['tv umpire'] && officials['tv umpire'] || []
  const reserveUmpire = officials['reserve umpire'] && officials['reserve umpire'] || []
  const referee = officials.referee && officials.referee || []
  const props = [
    debuts.length,
    umpire.length,
    tvUmpire.length,
    reserveUmpire.length,
    referee.length,
    hoursOfPlay,
    location.shortName,
    location.summary,
    venue,
    venueLink,
    temperature,
    playerOfMatch.length,
    playerOfSeries.length,
    matchFormat,
    featuredAthletesDetails.length
  ]
  let show = false

  // loops through all props and sets show=true
  // if any one of them is available
  for (var i = 0; i < props.length; i++) {
    if(props[i]) {
      show = true
    }
  }

  const content = (
    <div className={hideShowClass ? 'hide-show mobile' : ''}>
      <article className="sub-module game-information pre">
        <header>
          <h1>Match Details</h1>
        </header>
        <div className="content">
          <div className="match-detail-container">
            {
              venue &&
              <div className="stadium-details">
                <h4>
                  {
                    venueLink ? <a name={venue} href={venueLink} ><span>{venue}</span></a> : <span>{venue}</span>
                  }
                </h4>
              </div>
            }
            {
              series.length && 
              <MatchDetailItem type="Series" persons={series} /> || null
            }
            {
              playersperside && 
              <OtherDetail type="Players per side" value={playersperside} /> || null
            }
            {
              toss && <OtherDetail type="Toss" value={toss} /> || null
            }
            {
              featuredAthletesDetails && featuredAthletesDetails.map( (item, i)=> {
                if (item[1].length === 0) {
                  return null
                }
                const featuredAthleteType = selectn('[0].featuredAthletesType', item[1]) || ''
                return <MatchDetailItem key={i} type={featuredAthleteType} persons={item[1]} />
              })
            }
            {
              seriesResult.length && 
              <OtherDetail type="Series result" value={seriesResult} /> || null
            }
            {
              matchNo.name &&
              <MatchDetailItem type="Match number" persons={[ matchNo ]} /> || null
            }
            {
              season.name &&
              <MatchDetailItem type = "Season" persons={[ season ]} /> || null
            }
            {
              hoursOfPlay && 
              <OtherDetail type="Hours of play (local time)" value={hoursOfPlay} /> || null
            }
            {
              matchDays.length &&
              <OtherDetail type= "Match days" value={matchDays} /> || null
            }
            {
              debuts.length &&
              <MatchDetailItem type={matchFormat + ' debut'} persons={debuts} /> || null
            }
            {
              playerReplacement.map( (item)=> {
                const links = item.links || []
                if (links.length === 0) {
                  return null
                }
                return (
                  <div className="match-detail--item">
                    <div className="match-detail--left">
                      <h4>{item.text}</h4>
                    </div>
                    <div className="match-detail--right">
                    {
                      links.map( (link) => {
                        return (
                          <span dangerouslySetInnerHTML={{ __html : link }} />
                        )
                      })
                    }
                    </div>
                  </div>
                )
              })
            }
            {
              umpire.length &&
              <MatchDetailItem type="Umpires" persons={officials.umpire} /> || null
            }
            {
              tvUmpire.length &&
              <MatchDetailItem type="TV Umpires" persons={officials['tv umpire']} /> || null
            }
            {
              reserveUmpire.length &&
              <MatchDetailItem type="Reserve Umpire" persons={officials['reserve umpire']} /> || null
            }
            {
              referee.length &&
              <MatchDetailItem type="Match Referee" persons={officials.referee} /> || null
            }
            {
              points.length &&
              <OtherDetail type="Points" value={points} /> || null
            }
            {
              ballsPerOver.length &&
              <OtherDetail type="Balls per over" value={ballsPerOver} /> || null
            }
          </div>
        </div>
      </article>
    </div>
  )

  return show ? content : <article className="sub-module game-information pre"/>

}

export default MatchDetails
''



// WEBPACK FOOTER //
// ../app/components/gamepackage/cricket/MatchDetails.jsx